<template>
	<div>
		<a href="#" v-on:click.prevent="openModal();" v-if="!loading && usuario.NOMBRE">
			{{usuario.NOMBRE}}
		</a>
		<span v-if="loading">
			  <i class="fas fa-spinner fa-pulse"></i>
		</span>
		<span v-if="!usuario.NOMBRE" class="text-muted">
			-- No definido --
		</span>
		<div class="modal fade" role="dialog" aria-labelledby="userInfoModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="userInfoModalLabel">
							{{usuario.CODIGO_USUARIO}} | {{usuario.NOMBRE}}
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<preloader v-if="loading"></preloader>
						<div v-else class="row">
							<div class="col-md-6 mb-3">
				                <div class="media">
				                    <div class="align-self-center mr-3" title="Fecha Creación">
				                        <i class="material-icons">people</i>
				                    </div>
				                    <div class="media-body">
				                        <small>Perfil:</small>
				                        <p class="m-0" v-if="usuario.PERFIL == 'A'">
				                            Administrador
				                        </p>
				                        <p class="m-0" v-if="usuario.PERFIL == 'V'">
				                            Vendedor
				                        </p>
				                        <p class="m-0" v-if="usuario.PERFIL == 'S'">
				                            Jefe Sucursal
				                        </p>
				                        <p class="m-0" v-if="usuario.PERFIL == 'U'">
				                            Super Usuario
				                        </p>
				                    </div>
				                </div>
				            </div>

				            <div class="col-md-6 mb-3">
				                <div class="media">
				                    <div class="align-self-center mr-3" title="Fecha Creación">
				                        <i class="material-icons">email</i>
				                    </div>
				                    <div class="media-body">
				                        <small>
				                        	Correo Electrónico
				                        </small>
				                        <p class="m-0">
				                            <a v-bind:href="'mailto:'+usuario.CORREO">
				                            	{{usuario.CORREO}}
				                            </a>
				                        </p>
				                    </div>
				                </div>
				            </div>

				            <div class="col-md-6 mb-3">
				                <div class="media">
				                    <div class="align-self-center mr-3" title="Fecha Creación">
				                        <i class="material-icons">wc</i>
				                    </div>
				                    <div class="media-body">
				                        <small>
				                        	Sexo
				                        </small>
				                        <p class="m-0" v-if="usuario.SEXO=='M'">
				                            Masculino
				                        </p>
				                        <p class="m-0" v-if="usuario.SEXO=='F'">
				                        	Femenino
				                        </p>
				                        <p v-if="!usuario.SEXO">
				                        	<span class="text-muted">
				                        		-- No definido --
				                        	</span>
				                        </p>
				                    </div>
				                </div>
				            </div>

				            <div class="col-md-6 mb-3">
				                <div class="media">
				                    <div class="align-self-center mr-3" title="Fecha Creación">
				                        <i class="material-icons">verified_user</i>
				                    </div>
				                    <div class="media-body">
				                        <small>
				                        	Estado:
				                        </small>
				                        <p class="m-0" v-if="usuario.ESTADO=='1'">
				                            Activo
				                        </p>
				                        <p class="m-0" v-else>
				                        	Desactivo
				                        </p>
				                    </div>
				                </div>
				            </div>

				            <div class="col-md-6 mb-3">
				                <div class="media">
				                    <div class="align-self-center mr-3" title="Fecha Creación">
				                        <i class="material-icons">today</i>
				                    </div>
				                    <div class="media-body">
				                        <small>
				                        	Fecha Nacimiento:
				                        </small>
				                        <p class="m-0">
				                            {{usuario.FECHA_NACIMIENTO}}
				                        </p>
				                    </div>
				                </div>
				            </div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default{
		props: ['data'],

		mounted() {
			if (this.data) {
				this.getUsuario();
			}
	    },

	    data(){
        	return {
        		usuario: {
        			CODIGO_EMPRESA: '',
					CODIGO_USUARIO: '',
					NOMBRE: '',
					PERFIL: '',
					CORREO: '',
					SEXO: '',
					ESTADO: '',
					FECHA_NACIMIENTO: '',
					FECHA_CREACION: '',
					FECHA_ACTUALIZACION: '',
					CREADO_POR: '',
					ACTUALIZADO_POR: '',
					CREADO_DESDE: '',
					ACTUALIZADO_DESDE: '',
					AVATAR_URL: '',
					MODE_TEMPLATE: '',
					PORTADA: '',
					CODIGO_CLIENTE: '',
					BASE_DATOS: '',
        		},
        		loading: false,
        	}
        },

        methods: {
        	getUsuario: function(){
        		this.loading = true;
				var url = '/api/usuarios/'+this.data;
				axios.get(url).then(response => {
					this.setUser(response.data);
				}).catch(error =>{
					//this.$toasted.show('Error al cargar Usuario.');
					console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			openModal: function(){
				$(this.$el).children('.modal').modal('show');
			},

			setUser: function(data){
				this.usuario.CODIGO_EMPRESA = data.CODIGO_EMPRESA;
				this.usuario.CODIGO_USUARIO = data.CODIGO_USUARIO;
				this.usuario.NOMBRE = data.NOMBRE ? data.NOMBRE :  this.data;
				this.usuario.PERFIL = data.PERFIL;
				this.usuario.CORREO = data.CORREO;
				this.usuario.SEXO = data.SEXO;
				this.usuario.ESTADO = data.ESTADO;
				this.usuario.FECHA_NACIMIENTO = data.FECHA_NACIMIENTO;
				this.usuario.FECHA_CREACION = data.FECHA_CREACION;
				this.usuario.FECHA_ACTUALIZACION = data.FECHA_ACTUALIZACION;
				this.usuario.CREADO_POR = data.CREADO_POR;
				this.usuario.ACTUALIZADO_POR = data.ACTUALIZADO_POR;
				this.usuario.CREADO_DESDE = data.CREADO_DESDE;
				this.usuario.ACTUALIZADO_DESDE = data.ACTUALIZADO_DESDE;
				this.usuario.AVATAR_URL = data.AVATAR_URL;
				this.usuario.MODE_TEMPLATE = data.MODE_TEMPLATE;
				this.usuario.PORTADA = data.PORTADA;
				this.usuario.CODIGO_CLIENTE = data.CODIGO_CLIENTE;
				this.usuario.BASE_DATOS = data.BASE_DATOS;
			},
		}
	}
</script>